import { render, staticRenderFns } from "./WGSpinnerModal.vue?vue&type=template&id=0f24ee90&scoped=true"
import script from "./WGSpinnerModal.vue?vue&type=script&lang=js"
export * from "./WGSpinnerModal.vue?vue&type=script&lang=js"
import style0 from "./WGSpinnerModal.vue?vue&type=style&index=0&id=0f24ee90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../calendar/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24ee90",
  null
  
)

export default component.exports